<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
    <div class="detailsContent">
      <Goods :type='type' :id='id'></Goods>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'
import Goods from '@/components/memberGoods'
export default {
  data () {
    return {
      navBlock: '商城  /  會員商品',
      navtitle:'新增商品',
      id: this.$route.query.id,
      type:'add',
    }
  },
  components: {
    NavBar,
    Goods
  }
};
</script>>



// WEBPACK FOOTER //
// src/pages/market/memberGoods/addMemberGoods.vue